import { get } from 'lodash';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('MdmSettingsModel', {
      mdmSettings: 'item',
    }),
  },
  methods: {
    getGroupTypeArray(groupId) {
      const mdmDevices = this.mdmSettings.mdmDevices[0];
      const groupTypes = [];

      // Gathers the groupsIds that are the default groups for each ADE/MDM enrollment type
      const defaultAdeIosIds = get(mdmDevices, 'ades.ios.defaultDeviceGroupObjectIds', []);
      const defaultAdeMacOsIds = get(mdmDevices, 'ades.macos.defaultDeviceGroupObjectIds', []);
      const defaultByodIosIds = get(mdmDevices, 'defaultIosUserEnrollmentDeviceGroupID', []);

      // Checks to see if the groupId of the Device Group exists
      // in any of the default enrollment group arrays.
      if (defaultAdeMacOsIds.indexOf(groupId) > -1) {
        groupTypes.push({ name: 'macOS Automated Device Enrollment', icon: 'apple' });
      }

      if (defaultAdeIosIds.indexOf(groupId) > -1) {
        groupTypes.push({ name: 'iOS/iPadOS Automated Device Enrollment', icon: 'ios' });
      }
      // defaultByodIosIds comes from the api as a string but will eventually be
      // converted to an array. Remove the array conversion of defaultByodIosIds on
      // line 31 once that work is complete
      if ([defaultByodIosIds].indexOf(groupId) > -1) {
        groupTypes.push({ name: 'iOS/iPadOS User Enrollment', icon: 'ios' });
      }
      return groupTypes;
    },
  },
};
